// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { DndContext, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

// Internal Dependencies
import { IsEmpty } from '../../common/checks';

const useStyles = makeStyles(() => ({
  sort: {
    zIndex: 1000000,
    cursor: 'grabbing',
  },
}));

const Sortable = ({ data, handleSort, renderItem }) => {
  const classes = useStyles();
  const sensors = useSensors(
    useSensor(TouchSensor),
    useSensor(MouseSensor),
  );

  const [items, setItems] = React.useState(data);

  React.useEffect(() => {
    setItems(data);
  }, [data]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (IsEmpty(active) || IsEmpty(over)) {
      return;
    }

    if (active.id !== over.id) {
      setItems((prev) => {
        const oldIndex = prev.findIndex((i) => i.id === active.id);
        const newIndex = prev.findIndex((i) => i.id === over.id);
        const sorted = arrayMove(prev, oldIndex, newIndex);
        const formatted = _.map(_.cloneDeep(sorted), (item, idx) => ({
          ...item,
          displayOrder: idx + 1,
        }));
        handleSort(formatted);
        return formatted;
      });
    }
  };

  return (
    <DndContext onDragEnd={handleDragEnd} sensors={sensors} modifiers={[restrictToVerticalAxis]}>
      <SortableContext
        items={items}
        strategy={verticalListSortingStrategy}
      >
        {items.map((item) => (
          <div key={item.id} className={classes.sort}>
            {renderItem(item)}
          </div>
        ))}
      </SortableContext>
    </DndContext>
  );
};

Sortable.propTypes = {
  data:       PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  handleSort: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
};

export default Sortable;
